import crudlModuleGenerator from '@/_CRUDL/modules/generator';

const multiple = `/${process.env.VUE_APP_BANKS_API_SUFFIX}/clients`;
const single = `/${process.env.VUE_APP_BANKS_API_SUFFIX}/clients/:uuid`;

export default crudlModuleGenerator('clients', {
  customKeys: {
    create: 'data',
    read: 'data',
    update: 'data',
    delete: 'data',
    list: 'data',
  },
  customEndpoints: {
    create: multiple,
    read: single,
    update: single,
    delete: single,
    list: multiple,
  },
});
